'use client';
import useMediaQuery from '@mui/material/useMediaQuery';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import SocialLinks from '@components/shared/SocialLinks';
import { imageFullWidthXs, imageFullWidthSmAndUp } from '@style/variables';
import Typography from '@mui/material/Typography';
import BrandDivider from '@components/BrandDivider';
import Container from '@mui/material/Container';
import { classNames } from '@repo/ui/src/utils/classNames';

const ProfileBanner = ({
  bannerImage,
  name,
  title,
  bannerContentAlignment,
  smallBanner,
  instagram,
  twitter,
  facebook,
  youtube,
  website,
}) => {
  const theme = useTheme();
  const xsOnly = useMediaQuery(theme.breakpoints.only('xs'));

  const imgUrl = buildImageSrc(
    bannerImage,
    xsOnly ? imageFullWidthXs : imageFullWidthSmAndUp,
    xsOnly ? 3 : 4,
    xsOnly ? 4 : 3,
  );

  const align = xsOnly ? 'left' : bannerContentAlignment || 'center';

  return (
    <div
      style={{
        background: `url('${imgUrl}') center center / cover no-repeat`,
      }}
      className={classNames(
        'tw-relative tw-max-h-[800px] tw-overflow-hidden',
        smallBanner ? 'tw-h-auto' : 'tw-h-[550px] sm:tw-h-[100vh]',
      )}
    >
      {!smallBanner && (
        <div
          className={classNames(
            'tw-h-full tw-w-full tw-absolute tw-z-0 tw-from-transparent tw-via-50% tw-via-[rgba(0,0,0,0.6)] tw-to-[rgba(0,0,0,0.6)]',
            bannerContentAlignment === 'right' && 'tw-bg-gradient-to-r',
            bannerContentAlignment === 'left' && 'tw-bg-gradient-to-r',
            bannerContentAlignment === 'center' && 'tw-bg-[rgba(0,0,0,0.6)]',
          )}
        />
      )}
      <Container
        sx={{
          position: 'relative',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Grid
          container
          display="flex"
          direction="column"
          alignItems={align === 'left' ? 'flex-start' : align === 'right' ? 'flex-end' : 'center'}
          px={{ xs: 2, sm: 4, md: 6 }}
          py={{ xs: 4, sm: 6 }}
        >
          <Grid item xs={12} sm={6} md={5} lg={4} xl={3}>
            {name && (
              <Typography
                component="h1"
                variant="h2"
                className="animate-in"
                sx={{ color: (theme) => theme.palette.neutral[50] }}
              >
                {name}
              </Typography>
            )}
            <BrandDivider
              className="tw-h-2 tw-w-[75px] tw-mb-6"
              align={align === 'center' ? 'center' : 'left'}
            />
            {title && (
              <Typography
                variant="body1"
                mt={3}
                mb={4}
                className="animate-in"
                sx={{ color: (theme) => theme.palette.neutral[50] }}
              >
                {title}
              </Typography>
            )}
            <div
              className={classNames(
                'animate-in tw-flex',
                align === 'center' ? 'tw-justify-center' : 'tw-justify-items-start',
              )}
            >
              <SocialLinks
                facebook={facebook}
                twitter={twitter}
                youtube={youtube}
                instagram={instagram}
                website={website}
              />
            </div>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default ProfileBanner;
